import { FC } from 'react';
import { TInfoBlock } from '../../infoBlock.components';
import { NotePinned } from './components/notePinned/notePinned.component';
import { AddressPinned } from './components/addressPinned/addressPinned.component';
import { Box } from '@mui/material';

export const AdditionalColumn: FC<TAdditionalColumn> = (props) => {
  const { isNotePinned, isAddressPinned } = props;

  return (
    <>
      {(isNotePinned || isAddressPinned) && (
        <Box sx={{ display: 'flex', gap: '16px' }}>
          <NotePinned isNotePinned={isNotePinned} />
          <AddressPinned isAddressPinned={isAddressPinned} />
        </Box>
      )}
    </>
  );
};

type TAdditionalColumn = Pick<TInfoBlock, 'isNotePinned' | 'isAddressPinned'>;
